import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Icon, Button, Fab, Card, Typography, Grid, IconButton } from "@material-ui/core";


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  gridContainerOuter: {
    margin: '6px -6px',
    display: 'flex',
    justifyContent: 'center'
  },
  gridItemInner: {
    padding: '0px 6px'
  },
  titleDiv: {
    padding: '8px 0px 12px 0px'
  },
  divTitle: {
    padding: 14,
    borderBottom: '1px solid lightgrey'
  },
  divContent: {
    padding: 12,
  },
  button: {
    margin: theme.spacing(1)
  },
  input: {
    display: "none"
  }
}));

export default function ButtonsComp() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      
      <div className={classes.titleDiv}>
        <Typography variant="h2">Buttons</Typography>
      </div>

      <Grid container className={classes.gridContainerOuter}>
        <Grid item xs={12} className={classes.gridItemInner}>
          <Card className={classes.cardBody}>
            <div className={classes.divTitle}>
              <Typography variant="h5" color="inherit">
                Contained Buttons
              </Typography>
            </div>
            <div className={classes.divContent}>
              <Button variant="contained" className={classes.button}>
                Default
              </Button>
              <Button variant="contained" color="primary" className={classes.button}>
                Primary
              </Button>
              <Button
                variant="contained"
                color="secondary"
                className={classes.button}
              >
                Secondary
              </Button>
              <Button
                variant="contained"
                color="secondary"
                disabled
                className={classes.button}
              >
                Disabled
              </Button>
              <Button
                variant="contained"
                href="#contained-buttons"
                className={classes.button}
              >
                Link
              </Button>
              <input
                accept="image/*"
                className={classes.input}
                id="contained-button-file"
                multiple
                type="file"
              />
              <label htmlFor="contained-button-file">
                <Button
                  variant="contained"
                  component="span"
                  className={classes.button}
                >
                  Upload
                </Button>
              </label>
            </div>
          </Card>
        </Grid>
      </Grid>

      <Grid container className={classes.gridContainerOuter}>
        <Grid item xs={12} className={classes.gridItemInner}>
          <Card className={classes.cardBody}>
            <div className={classes.divTitle}>
              <Typography variant="h5" color="inherit">
                Text Buttons
              </Typography>
            </div>
            <div className={classes.divContent}>
              <Button className={classes.button}>Default</Button>
              <Button color="primary" className={classes.button}>
                Primary
              </Button>
              <Button color="secondary" className={classes.button}>
                Secondary
              </Button>
              <Button disabled className={classes.button}>
                Disabled
              </Button>
              <Button href="#text-buttons" className={classes.button}>
                Link
              </Button>
              <input
                accept="image/*"
                className={classes.input}
                id="text-button-file"
                multiple
                type="file"
              />
              <label htmlFor="text-button-file">
                <Button component="span" className={classes.button}>
                  Upload
                </Button>
              </label>
            </div>
          </Card>
        </Grid>

      </Grid>

      <Grid container className={classes.gridContainerOuter}>
        <Grid item xs={12} className={classes.gridItemInner}>
          <Card className={classes.cardBody}>
            <div className={classes.divTitle}>
              <Typography variant="h5" color="inherit">
                Outlined Buttons
              </Typography>
            </div>
            <div className={classes.divContent}>
              <Button variant="outlined" className={classes.button}>
                Default
              </Button>
              <Button variant="outlined" color="primary" className={classes.button}>
                Primary
              </Button>
              <Button variant="outlined" color="secondary" className={classes.button}>
                Secondary
              </Button>
              <Button variant="outlined" disabled className={classes.button}>
                Disabled
              </Button>
              <Button
                variant="outlined"
                href="#outlined-buttons"
                className={classes.button}
              >Link</Button>
              <input
                accept="image/*"
                className={classes.input}
                id="outlined-button-file"
                multiple
                type="file"
              />
              <label htmlFor="outlined-button-file">
                <Button
                  variant="outlined"
                  component="span"
                  className={classes.button}
                >Upload</Button>
              </label>
              <Button variant="outlined" color="inherit" className={classes.button}>
                Inherit
              </Button>
            </div>
          </Card>
        </Grid>


      </Grid>

      <Grid container className={classes.gridContainerOuter}>
        <Grid item xs={12} className={classes.gridItemInner}>
          <Card className={classes.cardBody}>
            <div className={classes.divTitle}>
              <Typography variant="h5" color="inherit">
                Icon Buttons
              </Typography>
            </div>
            <div className={classes.divContent}>
              <IconButton className={classes.button} aria-label="Delete">
                <Icon>delete</Icon>
              </IconButton>
              <IconButton
                className={classes.button}
                aria-label="Delete"
                disabled
                color="primary"
              >
                <Icon>delete</Icon>
              </IconButton>
              <IconButton
                color="secondary"
                className={classes.button}
                aria-label="Add an alarm"
              >
                <Icon>alarm</Icon>
              </IconButton>
              <IconButton
                color="primary"
                className={classes.button}
                aria-label="Add to shopping cart"
              >
                <Icon>add_shopping_cart</Icon>
              </IconButton>
              <input
                accept="image/*"
                className={classes.input}
                id="icon-button-file"
                type="file"
              />
              <label htmlFor="icon-button-file">
                <IconButton
                  color="primary"
                  className={classes.button}
                  aria-label="Upload picture"
                  component="span"
                >
                  <Icon>photo_camera</Icon>
                </IconButton>
              </label>
            </div>
          </Card>
        </Grid>


      </Grid>

      <Grid container className={classes.gridContainerOuter}>
        <Grid item xs={12} className={classes.gridItemInner}>
          <Card className={classes.cardBody}>
            <div className={classes.divTitle}>
              <Typography variant="h5" color="inherit">
                Different Size Buttons
                    </Typography>
            </div>
            <div className={classes.divContent}>
              <Fab
                size="small"
                color="secondary"
                aria-label="Add"
                className={classes.button}
              >
                <Icon>add</Icon>
              </Fab>
              <Fab
                size="medium"
                color="secondary"
                aria-label="Add"
                className={classes.button}
              >
                <Icon>add</Icon>
              </Fab>
              <Fab color="secondary" aria-label="Add" className={classes.button}>
                <Icon>add</Icon>
              </Fab>
            </div>
          </Card>
        </Grid>


      </Grid>

      <Grid container className={classes.gridContainerOuter}>
        <Grid item xs={12} className={classes.gridItemInner}>
          <Card className={classes.cardBody}>
            <div className={classes.divTitle}>
              <Typography variant="h5" color="inherit">
                Outlined Buttons
                    </Typography>
            </div>
            <div className={classes.divContent}>
              <Fab color="primary" aria-label="Add" className={classes.button}>
                <Icon>add</Icon>
              </Fab>
              <Fab color="secondary" aria-label="Edit" className={classes.button}>
                <Icon>edit_icon</Icon>
              </Fab>
              <Fab variant="extended" aria-label="Delete" className={classes.button}>
                <Icon className="mr-8">navigation</Icon>
                Extended
              </Fab>
              <Fab disabled aria-label="Delete" className={classes.button}>
                <Icon>delete</Icon>
              </Fab>
            </div>
          </Card>
        </Grid>


      </Grid>

    </div>
  );
}
